// extracted by mini-css-extract-plugin
export default {"aboutBox":"AboutMe_aboutBox__mlP7w","aboutWrapper":"AboutMe_aboutWrapper__S6rGA","aboutInner":"AboutMe_aboutInner__JMbjE","animation":"AboutMe_animation__LQvaq"};